import React from 'react'

export enum ArrowSide {
  DOWN = 'DOWN',
  LEFT = 'LEFT',
  RIGHT = 'RIGHT',
  UP = 'UP'
}

type PropsType = {
  color?: string
  onClick?: () => void
  side?: ArrowSide
  size?: number
}

const ARROW_PATHS = {
  [ArrowSide.LEFT]: 'M20 11H7.83L13.42 5.41L12 4L4 12L12 20L13.41 18.59L7.83 13H20V11Z',
  [ArrowSide.RIGHT]: 'M12 4L10.59 5.41L16.17 11H4V13H16.17L10.59 18.59L12 20L20 12L12 4Z',
  [ArrowSide.UP]: 'M20 12L18.59 13.41L13 7.83V20H11V7.83L5.42 13.42L4 12L12 4L20 12Z',
  [ArrowSide.DOWN]: 'M20 12L18.59 10.59L13 16.17V4H11V16.17L5.42 10.58L4 12L12 20L20 12Z'
}

const Arrow = ({ color = '#98A1B2', onClick, side = ArrowSide.LEFT, size = 24 }: PropsType) => (
  <svg
    height={size}
    onClick={onClick}
    viewBox='0 0 24 24'
    width={size}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path d={ARROW_PATHS[side]} fill={color} />
  </svg>
)

export default Arrow
